module.exports = __webpack_public_path__ + "img/safari.103b5ceb.svg";